import {createRouter, createWebHistory} from 'vue-router'
import LandingPage from '../pages/LandingPage'
import ContactPage from '../pages/ContactPage'
import MenuPage from '../pages/MenuPage'
import AboutUs from '../pages/AboutUs'
import HomePage from '../pages/HomePage'

const routes = [
    {
        path:'/',
        name: 'Landing',
        component:LandingPage,
        meta:{requiresFooter:false, requiresPoemHeader:true, requiresPoemFooter:true, isPhone:true},
        beforeEnter: (to, from, next) => {
            let isMobile = Math.min(window.screen.width, window.screen.height) < 768 || navigator.userAgent.indexOf("Mobi") > -1;
            if(isMobile){
                next("/home")
            }else{
                next()
            }
        }

    },

    {
        path:'/home',
        name: 'Home',
        component: HomePage,
        meta:{requiresFooter:true}
    },

    {
        path:'/contact-us',
        name: 'Contact-us',
        component: ContactPage,
        meta:{requiresFooter:true}
    },

    {
        path:'/menu',
        name: 'Menu',
        component: MenuPage,
        meta:{requiresFooter:true}
    },

    {
        path:'/about',
        name: 'About',
        component: AboutUs,
        meta:{requiresFooter:true}
    },
   

]




const router = createRouter({history:createWebHistory(),routes})
export default router